import axios from "axios";

const ENDPOINTS = {
  DEV: "http://0.0.0.0:8080",
  TEST: "https://subject-compass-test.uac.edu.au:8443",
  PROD: "https://subject-compass.uac.edu.au/",
};

export const api = axios.create({
  withCredentials: true,
  baseURL: ENDPOINTS.PROD,
});
